export const decodePrePopToken = (prepopulationToken?: string) => {
    if (prepopulationToken == null) return ''
    const decodedToken = decodeURIComponent(prepopulationToken)
    return decodedToken
}
